/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "info-card-item-value"
};
var _hoisted_2 = {
  class: "info-card-item-label"
};
export default /*#__PURE__*/_defineComponent({
  __name: 'InfoCard',
  props: {
    data: {},
    size: {
      default: 'default'
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var _toRefs = toRefs(props),
      size = _toRefs.size,
      data = _toRefs.data;
    var clazz = computed(function () {
      var isSmall = _.eq(size.value, 'small');
      return {
        small: isSmall
      };
    });
    var columnNum = computed(function () {
      var II = 2;
      var III = 3;
      if (_.size(data.value) % II) return III;
      return II;
    });
    onMounted(function () {
      return [console.log('data=>', _.size(data.value))];
    });
    return function (_ctx, _cache) {
      var _component_van_grid_item = _resolveComponent("van-grid-item");
      var _component_van_grid = _resolveComponent("van-grid");
      var _directive_ins = _resolveDirective("ins");
      return _openBlock(), _createBlock(_component_van_grid, {
        gutter: 10,
        class: "info-card",
        border: false,
        "column-num": _unref(columnNum)
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), function (item, index) {
            return _openBlock(), _createBlock(_component_van_grid_item, {
              key: index,
              class: _normalizeClass([_unref(clazz), "info-card-item"])
            }, {
              icon: _withCtx(function () {
                return [_withDirectives(_createElementVNode("span", _hoisted_1, null, 512), [[_directive_ins, item.value]])];
              }),
              text: _withCtx(function () {
                return [_createElementVNode("span", _hoisted_2, _toDisplayString(item.label), 1)];
              }),
              _: 2
            }, 1032, ["class"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["column-num"]);
    };
  }
});